import { DsLanguageMap, DsDropshippingGuideI18nTemplate } from './dsTypes';

export const dsLandingTemplate: DsLanguageMap<DsDropshippingGuideI18nTemplate['landing']> = {
  zh: {
    navYourOms: '你的 OMS',
    heroTitleLine1: '海外仓一件代发',
    heroTitleLine2: '目前最快的跨境履约方式',
    heroDescription: '从海外仓发货，出单后 2–5 天送达。',
    actionLearnMore: '了解详情',
    actionShippingCalculator: '运费试算',
  },
  en: {
    navYourOms: 'Your OMS',
    heroTitleLine1: 'Overseas Warehouse Dropshipping',
    heroTitleLine2: 'The fastest cross-border fulfillment model',
    heroDescription: 'Ship from overseas warehouses with delivery in 2–5 days.',
    actionLearnMore: 'Learn more',
    actionShippingCalculator: 'Shipping calculator',
  },
};
